var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"loading-container"},[_c('div',{staticClass:"loading-wrapper"},[_c('div',{staticClass:"loading-spinner"}),_c('div',{staticClass:"loading-text"},[_vm._v(_vm._s(_vm.text))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }